import React from 'react';
import Logo from '../images/logo.png';
import whatsAppLogo from '../images/whats_app_logo.png';
import instaLogo from '../images/insta_logo.png';
import tiktokLogo from '../images/tiktok_logo.png';
import phoneLogo from '../images/phone_logo.png';
import addressLogo from '../images/address_logo.png';
// import messageLogo from '../images/message_logo.png';
import emailLogo from '../images/email2_logo.png';

const BusinessCard = () => {
  const whatsApp = 'Jane_doe123'; // Replace with actual KakaoTalk ID

  // Function to create and download a vCard file
  const downloadVCard = () => {
    const vCardData = `
BEGIN:VCARD
VERSION:3.0
N:Doe;Jane
FN:Jane Doe
TEL;TYPE=CELL:1234567890
ADR;TYPE=WORK:123 Main St, Anytown, 12345
EMAIL:jane.doe@example.com
URL;TYPE=Instagram:https://www.instagram.com/jane_doe
URL;TYPE=TikTok:https://www.tiktok.com/@jane_doe
X-SOCIALPROFILE;TYPE=WhatsApp:${whatsApp}
END:VCARD
`;
    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', 'Jane_Doe_Contact.vcf');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Function to copy KakaoTalk ID to clipboard and display alert
  const copywhatsApp = () => {
    navigator.clipboard.writeText(whatsApp);
    alert('KakaoTalk ID is copied to clipboard!');
  };

  return (
    <div className="max-w-sm mx-auto bg-white p-5 shadow-lg rounded-lg relative">
      <div className="text-center mb-4">
        <img src={Logo} alt="Jane Doe Logo" className="mx-auto w-25 h-25 mb-2" />
      </div>
      <h1 className="text-xl font-bold text-center mb-4 text-black">Jane Doe</h1>
      <div className="flex items-center mb-3 text-black">
        <img src={phoneLogo} alt="Phone" className="w-6 h-6 mr-2" />
        <a href="tel:+11234567890" className="text-black">+1 123-456-7890</a>
      </div>
      <div className="flex items-center mb-3 text-black">
        <img src={addressLogo} alt="Address" className="w-6 h-6 mr-2" />
        <a 
          href="https://www.google.com/maps/search/?api=1&query=123+Main+St,+Anytown,+12345" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-black"
        >
          123 Main St, Anytown, 12345
        </a>
      </div>
      <div className="flex items-center mb-3 text-black">
        <img src={emailLogo} alt="Email" className="w-6 h-6 mr-2" />
        <a href="mailto:jane.doe@example.com" className="text-black">jane.doe@example.com</a>
      </div>
      <div className="flex justify-around mt-5">
        <img 
          src={whatsAppLogo} 
          alt="Kakao" 
          className="w-10 h-10 cursor-pointer" 
          onClick={copywhatsApp} 
          title="Click to Copy KakaoTalk ID" 
        />
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={instaLogo} alt="Instagram" className="w-10 h-10" />
        </a>
        <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer">
          <img src={tiktokLogo} alt="TikTok" className="w-10 h-10" />
        </a>
      </div>
      <div className="flex justify-center mt-3">
        <button onClick={downloadVCard} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full shadow-lg">
          Add to Contacts
        </button>
      </div>
    </div>
  );
};

export default BusinessCard;
